module.exports = "/_next/static/images/ed3c9826874b4334b80125cc7b003bef-notification.svg";